exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb-wrapper .ant-breadcrumb>span:first-child{font-size:22px}.breadcrumb-wrapper .ant-breadcrumb>span:nth-child(2){font-size:18px}.breadcrumb-wrapper .ant-breadcrumb>span:nth-child(3){font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/breadcrumbs.scss
// module id = 2153
// module chunks = 43